import React from "react";
import IconButton from "@mui/material/IconButton";
import EventIcon from "@mui/icons-material/Event";
import { EventTimes, TranslatedContent } from "../../../models";
import { FileDownloader } from "utils/fileDownloader";
import { eventsApi } from "api/instances";
import Loading from "modules/common/components/loading";

import "../../../styles/addToCalendar.sass";

class AddToCalendar extends React.Component<IAddToCalendarProps, IAddToCalendarState> {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
        };
    }

    public render() {
        const { startTime, loadingSize = 20 } = this.props;
        const hasStartTime: boolean = !!startTime;

        return (
            <div className="container">
                {this.state.isLoading ? (
                    <Loading size={loadingSize} />
                ) : (
                    <IconButton
                        color={hasStartTime ? "primary" : "default"}
                        title="Add to calendar"
                        size={hasStartTime ? "small" : undefined}
                        onClick={this.onAddToCalendar}
                        className={hasStartTime ? "add-time-to-calendar" : ""}
                    >
                        <EventIcon fontSize={hasStartTime ? "small" : "medium"} />
                    </IconButton>
                )}
            </div>
        );
    }

    private download = (content: string) => {
        const file = {
            name: `event-${new Date().toISOString()}.ics`,
            type: "text/calendar;charset=utf-8;",
        };
        new FileDownloader(file).downloadBlob(content);
    };

    private onAddToCalendar = async () => {
        try {
            if (this.props.eventId) {
                this.setState({ isLoading: true });
                let result = await eventsApi.getEventICS(this.props.eventId);
                this.download(result);
            }
        } catch {}
        this.setState({ isLoading: false });
    };
}

interface IAddToCalendarState {
    isLoading: boolean;
}

interface IAddToCalendarProps {
    activeLcid: string;
    eventTimes: EventTimes;
    location?: string;
    locationLink?: string;
    locationLinkLabel?: string;
    respondingEnabled?: boolean;
    translatedContent: TranslatedContent;
    eventId?: string;
    startTime?: string;
    loadingSize?: number;
}

export default AddToCalendar;
